export default "__VITE_ASSET__j4KvuIRS__"